import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

import { ENVIRONMENT_NAMES, getEnvironment } from "./deploymentUtils";

export function getURLGql() {
  const environment = getEnvironment();
  switch (environment) {
    case ENVIRONMENT_NAMES.LOCAL:
      return "https://761c9iup76.execute-api.us-east-1.amazonaws.com/dev/";
    case ENVIRONMENT_NAMES.LOCAL_DEV:
      return "https://761c9iup76.execute-api.us-east-1.amazonaws.com/dev/";
    case ENVIRONMENT_NAMES.TEST:
      return "https://2upkytev5l.execute-api.us-east-1.amazonaws.com/qa/";
    case ENVIRONMENT_NAMES.STABLE:
      return "https://zlzmy3wzj7.execute-api.us-east-1.amazonaws.com/stable/";
    case ENVIRONMENT_NAMES.DEV:
      return "https://761c9iup76.execute-api.us-east-1.amazonaws.com/dev/";
    case ENVIRONMENT_NAMES.PRD:
      return "https://e3yhdxxkhc.execute-api.us-east-1.amazonaws.com/prod/";
  }
}

export const API = {
  FAST_API: {
    URL: "https://35gh6sjzji.execute-api.us-east-1.amazonaws.com/dev/api/v5",
    TOKEN: "valid",
  },
  BACKEND: {
    URL: "$E2E_BACKEND_URL$",
  },
  COMPLAINTS: {
    URL: "$QUEJAS_RECLAMOS_BACKEND_URL$",
  },
};

const httpLink = createHttpLink({
  uri: API.COMPLAINTS.URL + "graphql/",
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("accessToken");
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});
